module.exports = __webpack_public_path__ + "images/gamesIcon-a5ace8c2a71d02ad8518d1b941625697.svg";